<script setup>
import { ref } from 'vue'
import accountForm from '../components/accountForm.vue'
import DiscordForm from '../components/discordForm.vue'
import premiumCard from '../components/premiumCard.vue'
import gameSettingsForm from '../components/gameSettingsForm.vue'
import streamOverlayForm from '../components/streamOverlayForm.vue'
import TransactionsCard from '../components/TransactionsCard.vue'
import NavRailItem from '../components/NavRailItem.vue'
import {
    DriverStore
} from '../pinia/Driver.js'
const Driver = DriverStore()

var dialog = ref(false)
var model = ref()
</script>

<template><NavRailItem icon="cog" label="Settings" @click="dialog = true" />

  <v-dialog transition="dialog-bottom-transition" :width="780" v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark color="primary" class="settings-toolbar">
        <v-icon class="mr-2">mdi-cog</v-icon>
        <div class="toolbar-content">
          <v-toolbar-title class="toolbar-main-title">Settings</v-toolbar-title>
          <div class="toolbar-subtitle">Manage your account and preferences</div>
        </div>
        <v-spacer />

        <template v-slot:extension>
          <v-tabs v-model="model" class="settings-tabs" show-arrows density="compact" selected-class="settings-tab-active">
            <v-tab value="1" class="settings-tab">
              <v-icon size="18" class="tab-icon">mdi-account</v-icon>
              <span class="tab-label">Account</span>
            </v-tab>
            <v-tab value="2" class="settings-tab">
              <v-icon size="18" class="tab-icon">mdi-controller</v-icon>
              <span class="tab-label">Game</span>
            </v-tab>
            <v-tab value="3" class="settings-tab">
              <v-icon size="18" class="tab-icon">mdi-discord</v-icon>
              <span class="tab-label">Discord</span>
            </v-tab>
            <v-tab value="6" class="settings-tab">
              <v-icon size="18" class="tab-icon">mdi-twitch</v-icon>
              <span class="tab-label">Streamer</span>
            </v-tab>
            <v-tab value="4" class="settings-tab">
              <v-icon size="18" class="tab-icon">mdi-crown</v-icon>
              <span class="tab-label">Premium</span>
            </v-tab>
            <v-tab value="5" class="settings-tab">
              <v-icon size="18" class="tab-icon">mdi-receipt-text</v-icon>
              <span class="tab-label">Transactions</span>
            </v-tab>
          </v-tabs>
        </template>

      </v-toolbar>

      <v-card-text>
        <v-window v-model="model">
          <v-window-item value="1">
            <accountForm />
          </v-window-item>
          <v-window-item value="2">
            <gameSettingsForm />
          </v-window-item>
          <v-window-item value="3">
            <DiscordForm />
          </v-window-item>
          <v-window-item value="6">
            <streamOverlayForm />
          </v-window-item>
          <v-window-item value="4">
            <premiumCard />
          </v-window-item>
          <v-window-item value="5">
            <TransactionsCard />
          </v-window-item>
        </v-window>
      </v-card-text>

    </v-card>
  </v-dialog></template>

<style scoped>
#menu {
  margin-bottom:10px!important}
.downloadbtn {
  display:flex;
  justify-content:center;
  margin:10px 0}
span {
  margin:0}
button {
  margin:initial!important}
.settings-toolbar {
  padding:8px 16px!important}
.toolbar-content {
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  gap:2px}
.toolbar-main-title {
  font-size:1.25rem!important;
  font-weight:600!important;
  line-height:1.2!important}
.toolbar-subtitle {
  font-size:.85rem;
  color:var(--ink-soft);
  line-height:1}
.settings-tabs {
  width:100%}
.settings-tabs .v-slide-group__content {
  justify-content:flex-start}
.settings-tab {
  min-width:0!important;
  flex:0 0 auto;
  padding:0 12px!important;
  letter-spacing:.01em;
  text-transform:none;
  font-size:.82rem;
  gap:6px}
.tab-icon {
  margin-inline-end:0!important}
.tab-label {
  white-space:nowrap}
@media (max-width: 720px) {
.tab-label {
  display:none}
.settings-tab {
  padding:0 10px!important}

}
</style>
